import { render, staticRenderFns } from "./FollowUpContactHistory.vue?vue&type=template&id=6236402e&scoped=true&"
import script from "./FollowUpContactHistory.vue?vue&type=script&lang=js&"
export * from "./FollowUpContactHistory.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpContactHistory.vue?vue&type=style&index=0&id=6236402e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236402e",
  null
  
)

export default component.exports